import React, { useEffect, useState } from 'react'
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
//gregorian_en
import arrowleft from "../../../assets/img/icons/arrow-left.svg";
import arrowright from "../../../assets/img/icons/arrow-right.png";
import weekends from "react-multi-date-picker/plugins/highlight_weekends"
import { useParams } from 'react-router-dom';
import useFetch from '../../../hooks/useAxios';
import { DateObject ,getAllDatesInRange} from "react-multi-date-picker";
import moment from 'jalali-moment';
import PersianNumber from '../../shared/PersianNumber';
import trash from "../../../assets/img/icons/trash.svg"
import PersianNumberForDate from '../../shared/PersianNumberForDate';
import Button from '../../shared/Button';
import { useCreatePlace } from '../../../context/CreatePlaceContext';
import Input from '../../shared/Input';
import { useForm } from 'react-hook-form';
import cancel from "../../../assets/img/icons/close-circle.svg"
import UseWindowSize from '../../../Sizes/UseWindowSize';

const EditRecidencesTips = ({className ,selectedDay,closeModal,setSelectedDay,inforesidencedetail,costinNight,setCostinNight}) => {
  const [resdate, setresdate] = useState([]) 
  const { updatePlaceDetail, createInfoData,apiUpdateResideces } = useCreatePlace();

  const [chosenDate, setChosenDate] = useState([]) 
  const {code,slug}=useParams()
  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/residences/calender/${code}`,
    noHeader: true,
    trigger: true,
    argFunc:(res)=>setresdate(res.data)
    
   
  });

 
 const {
  handleSubmit,
  formState: { errors, isValid },
  control,
  reset,setValue
} = useForm({

});
const windowSize = UseWindowSize()

  return (
    <div  className="DateBoxModal" onClick={()=>closeModal()}>
            <div className='ChooseDate2month datebox' onClick={(e)=>e.stopPropagation()}>

        <div className="flex justify-between items-center ChooseDate2month--header">
          <div>
            <h4>تخفیف ویژه</h4>
            <p>برای هر تاریخ یا بازه زمانی که می خواهید تخفیف گذاری کنید ، روی آن کلیک کنید و تخفیف مورد نظر خود را درج کنید</p>
          </div>
         {/* <div className='flex gap-[32px]'>
         <button onClick={()=>setSelectedDay(null)} className="ChooseDate2month--header-button">
            <img src={trash}/>
            <div>
            پاک کردن تاریخ سفر
            </div>
             
          </button>
          <Button className="w-[224px]" varient="fifth" onClick={()=>closeModal()} >
           اعمال تاریخ
             
          </Button>
         </div> */}
          <div>
             <button onClick={()=>closeModal()}>
                 <img src={cancel}/>
             </button>
         </div>
        </div>
    <div
      className={` datebox ${className}`}
      onClick={e=>e.stopPropagation()}
    >
     
     <div onClick={e=>e.stopPropagation()}>
   { resdate.length > 0 && <Calendar
          value={selectedDay}
          onChange={dateObjects => {
            //console.log(dateObjects)
            setSelectedDay(getAllDatesInRange(dateObjects))
          }}
          
          showOtherDays
          calendar={persian}
           locale={persian_fa}
          disableYearPicker
          range
          numberOfMonths={windowSize === "sm" || windowSize === "md" || windowSize <"lg" ? 1 : 2}// Set numberOfMonths to 2
          mapDays={({ date ,selectedDate,today}) => {
            let props = {};
            let isWeekend = [5,6].includes(date.weekDay.index);
       
           
            let result = date.toDays() - today.toDays();
            if(result < 0){
             return{
               disabled:true,
               style: { color: "#ccc" },
             }
            }

            const reservedDays= resdate.filter(i=>i.reserve_status === "reserved")
            for (let x of reservedDays){
              if(x.date === new DateObject(date).convert(persian, gregorian_en).format("YYYY-MM-DD")){
                return{
                  disabled:true,
                  style: { color: "#ccc" },
                }
             }
              
            }


            const EntrancedReserved = resdate.filter(i=>i.reserve_status === "leaving_available")
            for (let x of EntrancedReserved){
              if(x.date === new DateObject(date).convert(persian, gregorian_en).format("YYYY-MM-DD") && 
              ( selectedDay === null )){
                return{
                  disabled:true,
                  style: { color: "#ccc" },
                }
             }
          
            }
       
          if(selectedDay?.length > 0 && date !== undefined && EntrancedReserved && EntrancedReserved?.length > 0){
            const isBefore =new Date(EntrancedReserved[0].date) > new Date(new DateObject(selectedDate[0]).convert(persian, gregorian_en).format("YYYY-MM-DD"));
            const isAfter =new Date(EntrancedReserved[0].date) < new Date(new DateObject(date).convert(persian, gregorian_en).format("YYYY-MM-DD"));
            if(isBefore){
              while(isAfter){
                return{
                  disabled:true,
                  style: { color: "#ccc" },

                }
              }

            }
          }
       const price =resdate.filter(
        i=>i.date === new DateObject(date).convert(persian, gregorian_en)
        .format("YYYY-MM-DD"))[0]?.price;

            return {
              children: (
                <div
                  className={`center-column day-box ${isWeekend ? "weekend-red":""}`}
                >
                  <div className='day-box-num Danafont' style={{ textAlign: "start" }}>{date.format("D")}</div>
                {price &&  <div className='day-box-price Danafont' style={{ textAlign: "end" }}>
                <PersianNumberForDate number={price}/>
                  </div>}
                </div>
              ),
            };
          }}
          renderButton={(direction, handleClick) =>
            <button className="arrow-button" onClick={handleClick}>
              {direction === "left"
                ? <img src={arrowright} />
                : <img src={arrowleft} />}
            </button>}
        />}
     </div>
    </div><form>
    <div  className='flex justify-between RequestForm items-end'>
      
      <Input
            name="title"
            control={control}
            errors={errors}
            placeholder=" از تاریخ"
            label="از تاریخ"
            className="seconadary-input"
            register={{
              required: " از تاریخ اجباری است"
            }}
          />
           <Input
            name="title"
            control={control}
            errors={errors}
            placeholder=" تا تاریخ"
            label="تا تاریخ"
            className="seconadary-input"
            register={{
              required: " تا تاریخ اجباری است"
            }}
          />
             <Input
            name="title"
            control={control}
            errors={errors}
            placeholder=" درصد تخفیف"
            label="درصد تخفیف"
            className="seconadary-input"
            register={{
              required: " درصد تخفیف اجباری است"
            }}
          />
          <Button varient="primary">
          تایید و ثبت

          </Button>
     
        
    </div> </form>
    </div>
    </div>
  )
}

export default EditRecidencesTips